import { useMemo } from 'react';
import type { LaunchStatus, UploadedFilter } from '../types/hypothesis';

interface FiltersShape {
  hypothesis: string[];
  flow: string[];
  technology: string[];
  customer: string | null;
  tpcFinishDate: string | null;
  status: LaunchStatus | null;
  search: string;
}

const DEFAULT_UPLOADED_FILTER: UploadedFilter = 'last_week';

const useFiltersActive = (
  filters: FiltersShape,
  uploadedFilter: UploadedFilter,
): boolean =>
  useMemo(
    () =>
      filters.hypothesis.length > 0 ||
      filters.flow.length > 0 ||
      filters.technology.length > 0 ||
      filters.customer !== null ||
      filters.tpcFinishDate !== null ||
      filters.status !== null ||
      filters.search.trim() !== '' ||
      uploadedFilter !== DEFAULT_UPLOADED_FILTER,
    [filters, uploadedFilter],
  );

export default useFiltersActive;
